<template>
  <span v-if="variant === 'PULSE'" class="dots-pulse flex flex-row gap-1">
    <span class="dot dot-1" :class="`color-${color}`"></span>

    <span class="dot dot-2" :class="`color-${color}`"></span>

    <span class="dot dot-3" :class="`color-${color}`"></span>
  </span>
</template>

<script lang="ts" setup>
type LoaderVariant = "PULSE";
export type Color = "primary" | "secondary" | "disabled";

withDefaults(
  defineProps<{
    variant?: LoaderVariant;
    color?: Color;
  }>(),
  {
    variant: "PULSE",
    color: "primary",
  }
);
</script>

<style lang="scss" scoped>
.dots-pulse {
  .dot {
    height: 0.7rem !important;
    width: 0.7rem !important;
    display: inline-block;
    border-radius: 50%;
    animation: pulse 1.2s infinite ease-in-out both;
    &.color-primary {
      @apply bg-white;
    }
    &.color-secondary {
      @apply bg-theme-3;
    }
    &.color-disabled {
      @apply bg-theme-disabled-e;
    }

    &-2 {
      animation-delay: 0.18s;
    }
    &-3 {
      animation-delay: 0.38s;
    }
  }
  @keyframes pulse {
    0%,
    80%,
    100% {
      -webkit-transform: scale(0.9);
      transform: scale(0.9);
    }
    40% {
      -webkit-transform: scale(1.15);
      transform: scale(1.15);
    }
  }
}
</style>
